import { render } from "./Socks.vue?vue&type=template&id=7280019e&scoped=true"
import script from "./Socks.vue?vue&type=script&lang=js"
export * from "./Socks.vue?vue&type=script&lang=js"

import "./Socks.vue?vue&type=style&index=0&id=7280019e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7280019e"]])

export default __exports__